import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ToggleButton from './components/toggle-button';

import { Changelog } from './changelog-loadable';

import * as S from './styles';

import { useChangelogPositionExperiment } from '../../hooks/experiments';

import { AppState } from '../../reducers';

const selectChangelogOpen = (state: AppState) => state.areas.changelog.isOpen;
const selectChangelogArticles = (state: AppState) =>
  state.areas.changelog.articles;

export default function ChangelogDesktop() {
  const dispatch = useDispatch();
  const articles = useSelector(selectChangelogArticles);
  const isOpen = useSelector(selectChangelogOpen);
  const changelogInHeader = useChangelogPositionExperiment();

  const toggleOpen = () => {
    if (!isOpen) {
      dispatch({ type: 'CHANGELOG_TOGGLE' });
    }
  };

  if (!articles || !articles.length) {
    return null;
  }

  return (
    <S.ChangelogWrapper>
      <ToggleButton
        onClick={toggleOpen}
        alternatePosition={!changelogInHeader}
      />

      {isOpen && (
        // Conditionally render this to not load the extra bundle on pageload
        <S.ChangelogModal
          visible={isOpen}
          alternatePosition={!changelogInHeader}
        >
          <Changelog />
        </S.ChangelogModal>
      )}
    </S.ChangelogWrapper>
  );
}
